'use strict';
/**
 * A CBOR tagged item, where the tag does not have semantics specified at the
 * moment, or those semantics threw an error during parsing. Typically this will
 * be an extension point you're not yet expecting.
 */

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Tagged = /*#__PURE__*/function () {
  /**
   * Creates an instance of Tagged.
   *
   * @param {Number} tag - the number of the tag
   * @param {any} value - the value inside the tag
   * @param {Error} err - the error that was thrown parsing the tag, or null
   */
  function Tagged(tag, value, err) {
    _classCallCheck(this, Tagged);

    this.tag = tag;
    this.value = value;
    this.err = err;

    if (typeof this.tag !== 'number') {
      throw new Error('Invalid tag type (' + typeof this.tag + ')');
    }

    if (this.tag < 0 || (this.tag | 0) !== this.tag) {
      throw new Error('Tag must be a positive integer: ' + this.tag);
    }
  }
  /**
   * Convert to a String
   *
   * @returns {String} string of the form '1(2)'
   */


  _createClass(Tagged, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.tag, "(").concat(JSON.stringify(this.value), ")");
    }
    /**
     * Push the simple value onto the CBOR stream
     *
     * @param {cbor.Encoder} gen The generator to push onto
     * @returns {number}
     */

  }, {
    key: "encodeCBOR",
    value: function encodeCBOR(gen) {
      gen._pushTag(this.tag);

      return gen.pushAny(this.value);
    }
    /**
     * If we have a converter for this type, do the conversion.  Some converters
     * are built-in.  Additional ones can be passed in.  If you want to remove
     * a built-in converter, pass a converter in whose value is 'null' instead
     * of a function.
     *
     * @param {Object} converters - keys in the object are a tag number, the value
     *   is a function that takes the decoded CBOR and returns a JavaScript value
     *   of the appropriate type.  Throw an exception in the function on errors.
     * @returns {any} - the converted item
     */

  }, {
    key: "convert",
    value: function convert(converters) {
      var er, f;
      f = converters != null ? converters[this.tag] : undefined;

      if (typeof f !== 'function') {
        f = Tagged['_tag' + this.tag];

        if (typeof f !== 'function') {
          return this;
        }
      }

      try {
        return f.call(Tagged, this.value);
      } catch (error) {
        er = error;
        this.err = er;
        return this;
      }
    }
  }]);

  return Tagged;
}();

module.exports = Tagged;